import withErrorWrapper from '../../../hoc/WithErrorWrapper';
import view from './BankingAccountCardView';

export default withErrorWrapper(view);
